declare namespace $ {

	export class $giper_baza_link_chip extends $mol_link {
		icon( ): string
		param( ): string
		link( ): $giper_baza_link
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=chip.view.tree.d.ts.map